import BaseApi from './BaseApi';

class UsersApi extends BaseApi {
  constructor(props) {
    super(props);

    this.API_NAME = 'users';
  }

  async getUsersForAdmin({ limit, offset }, { filter }) {
    return this.postRequest('admin', { data: { limit, offset, filter } });
  }

  async blockUser(userId) {
    return this.putRequest('block', { data: { userId } });
  }

  async unblockUser(userId) {
    return this.putRequest('unblock', { data: { userId } });
  }
}

export default new UsersApi();



// WEBPACK FOOTER //
// ./src/api/UsersApi.js